import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.clydeflow.com";

/**
 * Per-page SEO. Adds <title>, description, canonical, OG, JSON-LD.
 * @param {string} title
 * @param {string} description
 * @param {string} path - e.g. "/privacy" (without trailing slash). Defaults to "/".
 * @param {object} jsonLd - optional schema.org payload
 */
const SEO = ({
  title,
  description,
  path = "/",
  noindex = false,
  jsonLd,
  image = "https://customer-assets.emergentagent.com/job_automation-empire/artifacts/mql0jwy4_flow-logo.png",
}) => {
  const url = `${SITE}${path}`;
  const fullTitle = title?.includes("ClydeFlow") ? title : `${title} · ClydeFlow`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
